// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as FraudType from "../types/FraudType.bs.js";
import * as ActionType from "../types/ActionType.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as BlacklistType from "../types/BlacklistType.bs.js";
import * as TrustAndSafetyAssetsManager from "../../assets/TrustAndSafetyAssetsManager.bs.js";

var banIcon = TrustAndSafetyAssetsManager.getImage("ban-icon.svg");

var warningIcon = TrustAndSafetyAssetsManager.getImage("warning-icon.svg");

var spinnerIcon = TrustAndSafetyAssetsManager.getImage("spinner-icon.svg");

var checkIcon = TrustAndSafetyAssetsManager.getImage("check-icon.svg");

var infoIcon = TrustAndSafetyAssetsManager.getImage("info-icon.svg");

function BlacklistPartnerForm(Props) {
  var actionType = Props.actionType;
  var msisdn = Props.msisdn;
  var fraudType = Props.fraudType;
  var blacklistTypes = Props.blacklistTypes;
  var comment = Props.comment;
  var result = Props.result;
  var onActionTypeChange = Props.onActionTypeChange;
  var onMsisdnChange = Props.onMsisdnChange;
  var onFraudTypeChange = Props.onFraudTypeChange;
  var onBlacklistTypeToggle = Props.onBlacklistTypeToggle;
  var onCommentChange = Props.onCommentChange;
  var onSubmit = Props.onSubmit;
  var isSubmitting = Props.isSubmitting;
  var isBlacklist = actionType === /* Blacklist */0;
  var getResultMessage = function (param) {
    if (typeof result === "number") {
      return null;
    } else if (result.TAG === /* Success */0) {
      return React.createElement("div", {
                  className: "c-blacklist-partner-page__result-message c-blacklist-partner-page__result-message--success"
                }, React.createElement("img", {
                      alt: "",
                      src: checkIcon
                    }), React.createElement("span", undefined, result._0));
    } else {
      return React.createElement("div", {
                  className: "c-blacklist-partner-page__result-message c-blacklist-partner-page__result-message--error"
                }, React.createElement("img", {
                      alt: "",
                      src: warningIcon
                    }), React.createElement("span", undefined, result._0));
    }
  };
  var titleIcon = isBlacklist ? banIcon : checkIcon;
  var renderDescription = function (param) {
    if (actionType) {
      return React.createElement("div", {
                  className: "c-blacklist-partner-page__info-box"
                }, React.createElement("img", {
                      className: "c-blacklist-partner-page__info-box-icon",
                      alt: "",
                      src: infoIcon
                    }), React.createElement("span", undefined, ActionType.toDescription(actionType)));
    } else {
      return React.createElement("div", {
                  className: "c-blacklist-partner-page__info-box"
                }, React.createElement("img", {
                      className: "c-blacklist-partner-page__info-box-icon",
                      alt: "",
                      src: infoIcon
                    }), React.createElement("ul", {
                      className: "c-blacklist-partner-page__form-description-list"
                    }, React.createElement("li", undefined, React.createElement("strong", undefined, "Document blacklisting: "), "Registers the partner's documents (Aadhaar & DL) in a blacklisted documents table in real time, which is then used during onboarding."), React.createElement("li", undefined, React.createElement("strong", undefined, "Device blacklisting: "), "Registers the partner's last-used device fingerprint in a blacklisted devices table. Any new Go Online attempts from a blacklisted device are blocked via a parallel enforcement flow."), React.createElement("li", undefined, React.createElement("strong", undefined, "Face blacklisting: "), "Registers the partner's face biometric in the blacklist flow so biometric-based onboarding or verification checks can be blocked after investigation."), React.createElement("li", undefined, "All actions are logged for audit.")));
    }
  };
  return React.createElement("div", {
              className: "c-blacklist-partner-page__form-container"
            }, getResultMessage(undefined), React.createElement("div", {
                  className: "c-blacklist-partner-page__form-header"
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__form-title" + (
                        isBlacklist ? "" : " c-blacklist-partner-page__form-title--whitelist"
                      )
                    }, React.createElement("img", {
                          alt: "",
                          src: titleIcon
                        }), React.createElement("span", undefined, ActionType.toDisplayString(actionType)))), React.createElement("div", {
                  className: "c-blacklist-partner-page__form-description"
                }, renderDescription(undefined)), React.createElement("div", {
                  className: "c-blacklist-partner-page__action-toggle"
                }, Belt_Array.map(ActionType.allActionTypes, (function (at) {
                        var isActive = actionType === at;
                        var match = at ? [
                            checkIcon,
                            "c-blacklist-partner-page__action-toggle-icon c-blacklist-partner-page__action-toggle-icon--whitelist"
                          ] : [
                            banIcon,
                            "c-blacklist-partner-page__action-toggle-icon c-blacklist-partner-page__action-toggle-icon--blacklist"
                          ];
                        return React.createElement("button", {
                                    key: ActionType.toString(at),
                                    className: "c-blacklist-partner-page__action-toggle-button" + (
                                      isActive ? " c-blacklist-partner-page__action-toggle-button--active" : ""
                                    ),
                                    type: "button",
                                    onClick: (function (param) {
                                        return Curry._1(onActionTypeChange, at);
                                      })
                                  }, React.createElement("img", {
                                        className: match[1],
                                        alt: "",
                                        src: match[0]
                                      }), ActionType.toDisplayString(at));
                      }))), React.createElement("form", {
                  className: "c-blacklist-partner-page__form",
                  onSubmit: onSubmit
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__form-section"
                    }, React.createElement("div", {
                          className: "c-blacklist-partner-page__form-section-header"
                        }, React.createElement("span", {
                              className: "c-blacklist-partner-page__form-section-title"
                            }, isBlacklist ? "Blacklist Details" : "Whitelist Details")), React.createElement("div", {
                          className: "c-blacklist-partner-page__form-fields"
                        }, React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, "MSISDN *"), React.createElement("input", {
                                  className: "c-blacklist-partner-page__form-input",
                                  title: "MSISDN must contain only numbers",
                                  pattern: "[0-9]+",
                                  placeholder: "Enter MSISDN (e.g., 9876543210123)",
                                  required: true,
                                  type: "text",
                                  value: msisdn,
                                  onChange: (function ($$event) {
                                      return Curry._1(onMsisdnChange, $$event.target.value);
                                    })
                                })), isBlacklist ? React.createElement("div", {
                                className: "c-blacklist-partner-page__form-field"
                              }, React.createElement("label", {
                                    className: "c-blacklist-partner-page__form-label"
                                  }, "Fraud Type *"), React.createElement("select", {
                                    className: "c-blacklist-partner-page__form-input",
                                    required: true,
                                    value: Belt_Option.mapWithDefault(fraudType, "", FraudType.toString),
                                    onChange: (function ($$event) {
                                        var value = $$event.target.value;
                                        var ft = FraudType.fromString(value);
                                        if (ft !== undefined) {
                                          return Curry._1(onFraudTypeChange, ft);
                                        }
                                        
                                      })
                                  }, React.createElement("option", {
                                        disabled: true,
                                        value: ""
                                      }, "Select fraud type..."), Belt_Array.map(FraudType.allFraudTypes, (function (ft) {
                                          return React.createElement("option", {
                                                      key: FraudType.toString(ft),
                                                      title: FraudType.toDescription(ft),
                                                      value: FraudType.toString(ft)
                                                    }, FraudType.toDisplayString(ft));
                                        })))) : null, React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, isBlacklist ? "Blacklist Type *" : "Whitelist Type *"), React.createElement("div", {
                                  className: "c-blacklist-partner-page__checkbox-group"
                                }, Belt_Array.map(BlacklistType.allBlacklistTypes, (function (bt) {
                                        var isSupported = BlacklistType.isSupported(bt);
                                        var isChecked = Belt_Array.some(blacklistTypes, (function (t) {
                                                return t === bt;
                                              }));
                                        return React.createElement("label", {
                                                    key: BlacklistType.toString(bt),
                                                    className: "c-blacklist-partner-page__checkbox-item" + (
                                                      isSupported ? "" : " c-blacklist-partner-page__checkbox-item--disabled"
                                                    )
                                                  }, React.createElement("input", {
                                                        checked: isChecked,
                                                        disabled: !isSupported,
                                                        type: "checkbox",
                                                        onChange: (function (param) {
                                                            if (isSupported) {
                                                              return Curry._1(onBlacklistTypeToggle, bt);
                                                            }
                                                            
                                                          })
                                                      }), React.createElement("span", undefined, BlacklistType.toDisplayString(bt), isSupported ? null : React.createElement("span", {
                                                              className: "c-blacklist-partner-page__coming-soon"
                                                            }, " (Coming Soon)")));
                                      })))), React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, "Comment *"), React.createElement("textarea", {
                                  className: "c-blacklist-partner-page__form-textarea",
                                  placeholder: "Provide context for this action (e.g., ticket reference, investigation details)...",
                                  required: true,
                                  rows: 4,
                                  value: comment,
                                  onChange: (function ($$event) {
                                      return Curry._1(onCommentChange, $$event.target.value);
                                    })
                                }), React.createElement("div", {
                                  className: "c-blacklist-partner-page__form-hint"
                                }, "This will be visible in partner records and audit logs")))), React.createElement("div", {
                      className: "c-blacklist-partner-page__form-footer"
                    }, React.createElement("button", {
                          className: "c-blacklist-partner-page__submit-button",
                          disabled: isSubmitting,
                          type: "submit"
                        }, isSubmitting ? React.createElement(React.Fragment, undefined, React.createElement("img", {
                                    alt: "",
                                    src: spinnerIcon
                                  }), isBlacklist ? "Blacklisting..." : "Whitelisting...") : React.createElement(React.Fragment, undefined, React.createElement("img", {
                                    alt: "",
                                    src: checkIcon
                                  }), isBlacklist ? "Blacklist Partner" : "Whitelist Partner")))));
}

var make = BlacklistPartnerForm;

export {
  banIcon ,
  warningIcon ,
  spinnerIcon ,
  checkIcon ,
  infoIcon ,
  make ,
  
}
/* banIcon Not a pure module */
